import { render, staticRenderFns } from "./ProductivityView.vue?vue&type=template&id=1c847e30&"
import script from "./ProductivityView.vue?vue&type=script&lang=js&"
export * from "./ProductivityView.vue?vue&type=script&lang=js&"
import style0 from "./ProductivityView.vue?vue&type=style&index=0&id=1c847e30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports